<template>
	<ElderInput
		v-model="valueComp"
		v-bind="$attrs"
		v-on="$listeners"
		:class="[classComp, { 'elder-input--focus': focus }]"
		@focus="onCustomInputEvent('onFocus')"
		@blur="onCustomInputEvent('onBlur')"
	>
		<slot />
		<template v-for="(_, slot) of $scopedSlots" v-slot:[slot]="scope"><slot :name="slot" v-bind="scope" /></template>
	</ElderInput>
</template>

<script>
import { InputComponent as ElderInput } from 'vue-elder-input'
import { path } from 'ramda'
export default {
	props: {
		value: undefined,
		floatingLabel: Boolean,
	},
	data() {
		return {
			focus: false,
		}
	},
	computed: {
		valueComp: {
			get() {
				return this.value
			},
			set(val) {
				this.$emit('input', val)
			},
		},

		classComp() {
			let value = {}

			if (this.floatingLabel) {
				value['elder-input--inactive'] = !Boolean(this.valueComp) && !this.focus
			}

			return value
		},
	},
	methods: {
		onCustomInputEvent(event) {
			switch (event) {
				case 'onFocus':
					this.focus = true
					break
				default:
					this.focus = false
			}
		},
	},

	components: {
		ElderInput,
	},
}
</script>

<style lang="scss"></style>
